import React from 'react';
import CoreValuesPanel from './coreValuesPanel';
import SidebarOv from './sidebarOv';
import { BoardOv, SectionLabel, ViewRoot } from './styles';
import Timeline from './timeline';

interface OverviewViewProps {
  active: boolean;
}

const OverviewView: React.FC<OverviewViewProps> = ({ active }) => (
  <ViewRoot $active={active}>
    <SidebarOv />
    <BoardOv>
      <SectionLabel>So leben wir unsere IDG&apos;s</SectionLabel>
      <Timeline />
      <CoreValuesPanel />
    </BoardOv>
  </ViewRoot>
);

export default OverviewView;
